export const rootRoutes = {
  signIn: 'sign-in',
  signUp: 'sign-up',
  onboarding: 'onboarding',
} as const

export const orgRoutes = {
  chat: 'chat',
  conversation: 'c',
  settings: 'settings',
  profile: 'profile',
  agencies: 'agencies',
} as const

export const agencyRoutes = {
  explore: 'explore',
  studio: 'studio',
  organization: 'organization',
  new: 'new',
  edit: 'edit',
  templates: 'templates',
} as const

export const settingsRoutes = {
  general: 'general',
  members: 'members',
  balance: 'balance',
  paymentMethods: 'payment-methods',
  subscription: 'subscription',
  invoices: 'invoices',
  usageAudit: 'usage-audit',
  connectors: 'connectors',
} as const

export const billingRoutes = {
  billing: 'billing',
  plans: 'plans',
  topUp: 'top-up',
  redeemCode: 'redeem-code',
  usage: 'usage',
} as const

export const miscRoutes = {
  projects: 'projects',
  apiKeys: 'api-keys',
  security: 'security',
} as const

const systemReservedSlugs = ['admin', 'api', 'app', 'auth', 'deeplink', 'help'] as const

export const RESERVED_SLUGS: ReadonlySet<string> = new Set([
  ...Object.values(rootRoutes),
  ...Object.values(orgRoutes),
  ...Object.values(agencyRoutes),
  ...Object.values(settingsRoutes),
  ...Object.values(billingRoutes),
  ...Object.values(miscRoutes),
  ...systemReservedSlugs,
])
